import React from "react";
import siteConfig, { formatPrice } from "../config/siteConfig";
import PolicyLayout from "./PolicyLayout";

const sections = [
  { title: "How much is delivery?", body: [`Delivery is ${formatPrice(siteConfig.delivery.standardFee)} per order. The full charge is shown before payment.`] },
  { title: "How should chilled products be stored?", body: ["Refrigerate chilled items promptly after delivery and follow the storage and use-by information shown on the product packaging."] },
  { title: "Can I change an order?", body: [`Email ${siteConfig.contact.email} as soon as possible. We will help where preparation or dispatch has not already begun.`] },
  { title: "What if an item arrives damaged?", body: ["Keep the item and packaging, take clear photographs and contact us promptly with your order details so we can review the issue."] },
  { title: "Which payment methods are supported?", body: ["The secure payment page supports major card methods including Visa, Mastercard, American Express and UnionPay, subject to provider availability."] },
];

export default function Faqs() {
  return <PolicyLayout title="Frequently asked questions" intro="Useful answers about orders, delivery, storage and payment." sections={sections} />;
}
